import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppCommonCoreModule } from '@common/app-common-core.module';
import { CmsKeysBarComponent } from '@common/components/cms-keys-bar/cms-keys-bar.component';
import { CommandComponent } from '@common/components/command/command.component';
import { ContactOptionsComponent } from '@common/components/contact-options/contact-options.component';
import { ContentTooltipExtComponent } from '@common/components/content-tooltip-ext/content-tooltip-ext.component';
import { ContentComponent } from '@common/components/content/content.component';
import { ErrorComponent } from '@common/components/error/error.component';
import { SocialnetworkIconsComponent } from '@common/components/socialnetwork-icons/socialnetwork-icons.component';
import { VwoCapturerComponent } from '@common/components/vwo/vwo-capturer.component';
import { CmsToGoogleAnalyticsEventDirective } from '@common/directives/cms-ga-event.directive';
import { ContainsYoutubeDirective } from '@common/directives/contains-youtube.directive';
import { FitChildrenHeightDirective } from '@common/directives/fit-children-height.directive';
import { FocusFirstInvalidFieldDirective } from '@common/directives/focus-invalid.directive';
import { GoogleAnalyticsEventDirective } from '@common/directives/ga-event.directive';
import { HighlightDirective } from '@common/directives/highlight.directive';
import { InputRegexDirective } from '@common/directives/input-regex.directive';
import { RouteTransformerDirective } from '@common/directives/route-tranformer.directive';
import { YoutubeMovieDirective } from '@common/directives/youtube.movie.directive';
import { AbsoluteNumberPipe } from '@common/pipes/absolute-number.pipe';
import { CmsImageAltPipe } from '@common/pipes/cms-image-alt.pipe';
import { CmsImageSrcPipe } from '@common/pipes/cms-image-src.pipe';
import { CmsTextPipe } from '@common/pipes/cms-text.pipe';
import { EncodeURIComponentPipe } from '@common/pipes/encode-url-component.pipe';
import { FaqContentPipe } from '@common/pipes/faqcontent.pipe';
import { FaqHeaderPipe } from '@common/pipes/faqheader.pipe';
import { HighlightPipe } from '@common/pipes/highlight.pipe';
import { JpTextPipe } from '@common/pipes/jp-text.pipe';
import { ParamReplacementPipe } from '@common/pipes/param-replacement-pipe';
import { VwoVariantPipe } from '@common/pipes/vwo-variant.pipe';
import { YouTubePipe } from '@common/pipes/youtube.pipe';
import { JpDateInputFormatDirective } from '@lang/jp/directives/date-input-format-directive';
import { JpLangModule } from '@lang/jp/jp.lang.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
    imports: [CommonModule, AppCommonCoreModule, JpLangModule, NgSelectModule],
    exports: [
        HttpClientModule,
        NgbModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        HighlightPipe,
        FaqHeaderPipe,
        FaqContentPipe,
        ParamReplacementPipe,
        CmsTextPipe,
        JpTextPipe,
        CmsImageSrcPipe,
        CmsImageAltPipe,
        YouTubePipe,
        AbsoluteNumberPipe,
        EncodeURIComponentPipe,
        ContentComponent,
        CommandComponent,
        ErrorComponent,
        ContactOptionsComponent,
        CmsKeysBarComponent,
        ContentTooltipExtComponent,
        FocusFirstInvalidFieldDirective,
        RouteTransformerDirective,
        HighlightDirective,
        InputRegexDirective,
        GoogleAnalyticsEventDirective,
        YoutubeMovieDirective,
        ContainsYoutubeDirective,
        JpDateInputFormatDirective,
        SocialnetworkIconsComponent,
        CmsToGoogleAnalyticsEventDirective,
        FitChildrenHeightDirective,
        VwoCapturerComponent,
        VwoVariantPipe,
    ],
})
export class SharedModule {}
